export const siteConfig = {
  name: process.env.REACT_APP_SITE_NAME || "Sophia Sweeps",
  domain: process.env.REACT_APP_SITE_DOMAIN || "sophiasweeps.com",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "fea@sophiasweeps.com",
  logoUrl: process.env.REACT_APP_SITE_LOGO_URL || "/sophia-sweeps-logo.jpg",
  paymentUrl: process.env.REACT_APP_PAYMENT_URL || "https://playhubslots.com/c/sophia",
  guestEmailDomain: process.env.REACT_APP_GUEST_EMAIL_DOMAIN || "guest.sophiasweeps.local",
  storagePrefix: process.env.REACT_APP_STORAGE_PREFIX || "sophia",
};

export const storageKey = (name) => `${siteConfig.storagePrefix}_${name}`;
export const appEventName = (name) => `${siteConfig.storagePrefix}:${name}`;
